var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameplay-total"},[_c('p',{staticClass:"text3"},[_vm._v("Total")]),_c('p',{staticClass:"points-total"},[_vm._v(_vm._s(_vm.points))])])}
var staticRenderFns = []

export { render, staticRenderFns }